import { DirectiveOptions } from 'vue'

interface CollapsibleElement extends HTMLElement {
    isCollapsed?: boolean
    fullHeight?: number
    collapseTimeout?: NodeJS.Timer
}

const Collapse: DirectiveOptions = {
    inserted(el: CollapsibleElement, { value: collapse }: any): void {
        el.fullHeight = el.clientHeight
        // instant hide
        if (collapse) {
            el.style.transition = '0s'
            el.style.maxHeight = '0'
            el.style.opacity = '0'
            el.style.overflow = 'hidden'
            el.classList.add('collapsed')
            if (el.parentElement) {
                el.parentElement.classList.add('collapsed-child')
            }
            setTimeout(() => {
                el.style.transition = ''
            }, 1000)
        }
    },

    componentUpdated(el: CollapsibleElement, { value: collapse }: any): void {
        if (el.isCollapsed === collapse) return
        // toggle collapse
        if (collapse) {
            el.fullHeight = el.clientHeight
            // set max height
            el.style.maxHeight = `${el.fullHeight}px`
            // collapse "later"
            setTimeout(() => {
                if (el.collapseTimeout) {
                    clearTimeout(el.collapseTimeout)
                    el.collapseTimeout = undefined
                }
                el.style.maxHeight = '0'
                el.style.opacity = '0'
                el.style.overflow = 'hidden'
                el.classList.add('collapsed')
                if (el.parentElement) {
                    el.parentElement.classList.add('collapsed-child')
                }
            }, 50)
        } else if (el.fullHeight && el.fullHeight > 0) {
            el.style.maxHeight = `${el.fullHeight}px`
            el.classList.remove('collapsed')
            if (el.parentElement) {
                el.parentElement.classList.remove('collapsed-child')
            }
            el.collapseTimeout = setTimeout(() => {
                el.style.opacity = '1'
                el.style.overflow = 'initial'
                el.style.maxHeight = null
            }, 200)
        } else {
            el.style.maxHeight = 'auto'
            el.fullHeight = el.clientHeight
            el.classList.remove('collapsed')
            el.collapseTimeout = setTimeout(() => {
                el.style.opacity = '1'
                el.style.overflow = 'initial'
                el.style.maxHeight = null
            }, 200)
        }
        el.isCollapsed = collapse
    }
}

export default Collapse
